// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressFormController from "./address_form_controller"
application.register("address-form", AddressFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import SubdomainController from "./subdomain_controller"
application.register("subdomain", SubdomainController)

import TypeaheadController from "./typeahead_controller"
application.register("typeahead", TypeaheadController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import RegenerateLinkController from "./regenerate_link_controller"
application.register("regenerate-link", RegenerateLinkController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import BillingStartsToggleController from "./billing_starts_toggle_controller"
application.register("billing-starts-toggle", BillingStartsToggleController)

import BillingModeToggleController from "./billing_mode_toggle_controller"
application.register("billing-mode-toggle", BillingModeToggleController)

import VisitAllotmentToggleController from "./visit_allotment_toggle_controller"
application.register("visit-allotment-toggle", VisitAllotmentToggleController)

import ScheduleToggleController from "./schedule_toggle_controller"
application.register("schedule-toggle", ScheduleToggleController)

import ToggleFieldController from "./toggle_field_controller"
application.register("toggle-field", ToggleFieldController)

import CheckoutReturnController from "./checkout_return_controller"
application.register("checkout-return", CheckoutReturnController)

import DropInCheckoutController from "./drop_in_checkout_controller"
application.register("drop-in-checkout", DropInCheckoutController)

import ProgramAppearanceController from "./program_appearance_controller"
application.register("program-appearance", ProgramAppearanceController)

import MembershipPauseController from "./membership_pause_controller"
application.register("membership-pause", MembershipPauseController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import PageToolsController from "./page_tools_controller"
application.register("page-tools", PageToolsController)

